import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';
import { DeletedStickersRequest, DeleteStickerRequest, NfcStickerShort } from '../../core';
import { NfcRetailerStickersService } from '../nfc-retailer-stickers.service';
import { NotificationService } from './../../../../app.common/modules/common/services/notification.service';

class NfcRetailerDeletedTab {
    public static $inject = ['$scope', '$translate', '$uibModal', 'nfcRetailerStickersService', 'notificationService', 'popupService'];

    public waiting: boolean;
    public total: number;
    public items: NfcStickerShort[] = [];
    public filter: string;
    public itemsLimit: number = 20;
    public canLoadMore: boolean = true;
    public noDeletedStickersMessage: string = this.$translate.instant('nfc_deleted_tab_empty_stickers_message');

    public viewport = {
        width: $(window).width(),
        height: $(window).height(),
        scrollTop: 0
    };

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService,
        private popupService: PopupService,
    ) {
    }

    addDeletedSticker = async () => {
        let operationResult: any = await this.$uibModal.open({
            component: 'addDeletedSticker',
            resolve: {},
            size: 'md',
            backdrop: 'static',
        }).result;

        if (operationResult === 'ok') {
            this.applyFilter();
        }
    }

    restoreSticker = async (sticker: NfcStickerShort) => {
        try {
            await this.popupService.confirm({
                okClass: 'btn btn-with-icon btn-with-icon--before-close color-black54 bg-dark12',
                okTxt: this.$translate.instant('restore_deleted_sticker_dialog_cancel'),
                cancelClass: 'btn btn-with-icon btn-with-icon--before-confirm btn-success',
                cancelTxt: this.$translate.instant('restore_deleted_sticker_dialog_ok'),
                classPopup: 'alert--redesign modal360',
                title: this.$translate.instant('restore_deleted_sticker_dialog_title'),
                content: this.$translate.instant('restore_deleted_sticker_dialog_content'),
                invertAction: true
            });
        } catch (e) {
            return;
        }

        try {
            let requestToRestore : DeleteStickerRequest = { StickerNumber: sticker.ID };
            this.notificationService.showWaitingMessage();
            await this.nfcRetailerStickersService.restoreSticker(requestToRestore);
            this.items.splice(this.items.indexOf(sticker), 1);
            this.total -= 1;
        } catch (e) {
            this.notificationService.showErrorMessage(e);
        } finally {
            this.notificationService.clearAll();
        }
    }



    $onInit() {
        this.filter = '';
        this.loadData();
        $(window).resize(() => {
            this.viewport.width = $(window).width();
            this.viewport.height = $(window).height();
            this.$scope.$apply();
        });

        $(window).scroll(() => {
            this.viewport.scrollTop = $(document).scrollTop();
            this.$scope.$apply();
        });
    }

    applyFilter = () => {
        this.canLoadMore = true;
        this.items = [];
        this.total = 0;
        this.loadData();
    }

    private loadData = () => {
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.waiting = true;

        let lastItem = _.last(this.items);
        let lastStickerNumber = lastItem ? lastItem.ID : undefined;

        let filter: DeletedStickersRequest = {
            SearchAfterStickerID: lastStickerNumber,
            SearchTerm: this.filter,
            Limit: this.itemsLimit
        };

        this.notificationService.showWaitingMessage();

        return this.nfcRetailerStickersService.getDeletedStickers(filter)
            .then((response) => {
                this.total = response.Total;
                Array.prototype.push.apply(this.items, response.Items);
                this.canLoadMore = response.Items.length === this.itemsLimit;
            })
            .catch(error => this.notificationService.showErrorMessage(error))
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

}

angular.module('naut').component('nfcRetailerDeletedTab', {
    template: require('./nfc-retailer-deleted-tab.component.html'),
    controller: NfcRetailerDeletedTab,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/deleted-tab/nfc-retailer-deleted-tab.component.ts